/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Form as Formiker, Field as Fieldmik, Formik } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Input, Button, Dropdown, Icon, Segment, Divider, Label, Modal, Container } from 'semantic-ui-react'
import cogoToast from 'cogo-toast';
import { DateData } from '../apiInputComponent/dateData';
import MyVehicleNumber from './../apiInputComponent/myVehicleNo'
import Axios from 'axios';
import APP_CONSTANTS from '../../config/constants';
import MyVendor from '../apiInputComponent/myVendor';
import UploadFile from '../apiInputComponent/fileUpload';
import { MyInput, MyNormalInput, MyTextArea } from '../apiInputComponent/myInput';
import moment from 'moment';
import Services from './jobcardTypeComponent/service';
import MyJobcardType from '../apiInputComponent/myjobcardType';
import ReadAxios from '../axiosComponent/read';
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder';
import TitleBar from '../../components/titleBar/add_titleBar'
import VehicleJobcardHistory from './jobcardInfoComponent/vehicleJobcardHistory'

import { getVehicle } from '../../redux/actions/getApiActions'
import { updateApprovalStatus } from '../../redux/actions/jobCardActions'
import MyBranchAddVehicle from '../apiInputComponent/myBranchAddVehicle';
import JobcardActivity from '../apiInputComponent/jobcardActivity'

import AddProduct from './addProduct';

import AddModal from '../../components/commonComponent/addModal'
import TyreEdit from './jobcardTypeComponent/tyreEdit';
import BatteryEdit from './jobcardTypeComponent/batteryEdit';
import { jobcardTitles, jobCardValidations } from '../../utils/validationConstant';


const EditJobcard = (props) => {

  const [loadinginfo, setloadinginfo] = useState(false)
  const [infos, setinfos] = useState([])
  const [vehicleInfo, setvehicleInfo] = useState([])
  const [latestHistory, setlatestHistory] = useState([])
  const [tyreDetails, setTyreDetails] = useState([])
  const [tyreRun, setTyreRun] = useState([])
  const [batteryDetails, setBatteryDetails] = useState([])
  const [statusNameId, setstatusNameId] = useState('')
  const [statusName, setstatusName] = useState('')
  const [condroleId, setcondroleId] = useState([])
  const [jbConditionId, setjbConditionId] = useState({})
  const [valueForApproval, setValueForApproval] = useState('')
  const [meterDisabled, setMeterDisabled] = useState(false)
  const [approvalStatus, setApprovalStatus] = useState('')
  const [remarksModalOpen, setRemarksModalOpen] = useState(false)
  const [billNoExists ,setBillNoExists] =useState(false)
  const [invoiceUpload, setInvoiceUpload] = useState('')

  const { getVehicle, vehicleData, updateApprovalStatus } = props


  useEffect(() => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')
    let data = JSON.stringify
      ({
        api_token: token,
        customerNo: customerNo,
        jobCardTypeId:infos.length > 0 ?  infos[0].jb_type.jobCardTypeId : null,
        vehicleInDate: infos.length > 0 ? moment(infos[0].vehicleInDate).format('DD-MM-YYYY') : null,
        vehicleId:infos.length > 0 ? infos[0].vehicle_obj.vehicleId : null,
        userId: userId,
      })
    Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getJobCardApproverRole`, data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token
      }
    }).then((response => {
      if (response.data.status === 1) {
        let arr = []
        response.data.data.map((o) => {
          arr.push(o.roleId)
        })
        getRoleId(arr)
        getJbConditionId(response.data.data[0])
      } else {
        getRoleId([])
      }
    }))
      .catch(error => console.log(error))

  }, [infos])
  const checkInvoiceNo = (data) => {
    let val = data.target.value
    if(val){
      let userId = localStorage.getItem('userId')
      let customerNo = localStorage.getItem('customerNo')
      const data = {
        "customerNo": customerNo,
        "userId": userId,
        "invoiceNo": val
      }
      Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/getBillNoUniqueness`, data, {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": localStorage.getItem('apiToken'),
          "Access-Control-Allow-Origin": "*"
        }
      }).then((res) => {
        if (res.data.data.length > 0) {
          cogoToast.error('Bill No Already Exists')
          setBillNoExists(true)
        } else if(res.data.data.length == 0) {
          setBillNoExists(false)
        }
      }).catch(() => {
      })
    }
  }

  useEffect(() => {
    let jobcardId = props.location?.state?.id
    let vehicleId = props.location?.state?.vehicleId
    let jobCardType = props.location?.state?.jobCardType
    let token = localStorage.getItem('apiToken')
    let customerNo = localStorage.getItem('customerNo')
    let userId = localStorage.getItem('userId')
    setloadinginfo(true)

    getVehicle()
    ReadAxios({ url: 'fleet/jobcard/getJobCards', readItems: { jobCardId: jobcardId } }).then((res) => {
      let statusAproName = []
      res && res.map((o, i) => {
        let temp = {}
        temp.statusNameId = o.jb_approval_status ? o.jb_approval_status.approvalStatus : ''
        temp.statusName = o.jb_approval_status ? o.jb_approval_status.approvalStatusName : ''
        statusAproName[i] = temp
      })


      setloadinginfo(false)
      setstatusName(statusAproName[0].statusName)
      setstatusNameId(statusAproName[0].statusNameId)

      for (let index = 0; index < res.length; index++) {
        const element = res[index];
        if (res?.[index]?.jb_tyres?.length > 0) {

          let tyresInfo = res[index].jb_tyres
          let filteredTyreInfo = [];
          let tyreRunValues = [];
          if (tyresInfo) {
            tyresInfo.map((o, i) => {


              filteredTyreInfo[i] = {};
              filteredTyreInfo[i]['tyreRun'] = o.tyreRun
              filteredTyreInfo[i]['jbTyreId'] = o.jbTyreId
              filteredTyreInfo[i]['jobCardId'] = o.jobCardId
              filteredTyreInfo[i]['tyrePositionId'] = o.tyrePositionId
              filteredTyreInfo[i]['installationDate'] = o?.installationDate && o?.installationDate !== '0000-00-00' ? new Date(o.installationDate.split(" ")[0]) : new Date()

              o.installationDate
              filteredTyreInfo[i]['oldTyreMapId'] = o.oldTyreMapId
              filteredTyreInfo[i]['tyrePositionName'] = o.tyrePostionName
              filteredTyreInfo[i]['oldSerialNo'] = o.oldSerialNo;
              filteredTyreInfo[i]['serialNo'] = o.serialNo;
              filteredTyreInfo[i]['tyreInvId'] = o.tyreInvId
              filteredTyreInfo[i]['checkboxSelect'] = true
              filteredTyreInfo[i]['flag'] = 0
              filteredTyreInfo[i]['removeJobfromList'] = 0
              tyreRunValues.push(o.tyreRun)

            })
            res[index].tyreDetails = filteredTyreInfo;
            setTyreDetails(filteredTyreInfo);
            setinfos(res)
            setTyreRun('tyreRun', Math.max(...tyreRunValues))
          }
        } else if (res?.[index]?.jb_battery) {
          let batteryInfo = res[index].jb_battery
          let filteredBatteryInfo = [];
          let batteryRunValues = [];

          filteredBatteryInfo.jbBatteryId = batteryInfo.jbBatteryId
          filteredBatteryInfo.jobCardId = batteryInfo.jobCardId
          filteredBatteryInfo.oldSerialNumber = batteryInfo.oldSerialNo
          filteredBatteryInfo.oldBatteryMapId = batteryInfo.oldBatteryMapId
          filteredBatteryInfo.serialNo = {
            productInventoryId: batteryInfo.productInvId,
            serialNo: batteryInfo.serialNo
          }
          filteredBatteryInfo.checkboxSelect = true
          filteredBatteryInfo.installationDate = batteryInfo?.batteryInstallationDate ? batteryInfo.batteryInstallationDate.split(" ")[0] != '0000-00-00' ? new Date(batteryInfo.batteryInstallationDate.split(" ")[0]) : new Date() : new Date()

          res[index].batteryDetails = filteredBatteryInfo;
          setBatteryDetails(filteredBatteryInfo);
          setinfos(res)
        } else {
          setinfos(res)
        }
      }
    });

    let data = JSON.stringify
      ({
        api_token: token,
        customerNumber: customerNo,
        vehicleMasterId: vehicleId,
        userId
      })

    Axios.post(`${APP_CONSTANTS.BASE_URL}masters/vehicleMaster`, data, {
      headers: {
        'Accept': 'application/json',
        "Authorization": token,
        'Content-Type': 'application/json'
      }
    }).then((response => {
      let vehicleInfoArray = response.data.resultSet;
      setvehicleInfo(vehicleInfoArray);
    }))
      .catch(error => console.log(error))
  }, [])


  let fetchLatestHistory = (data) => {
    if (data) {
      setlatestHistory(data)
    } else {
      setlatestHistory([])
    }
  }


  const handleDoc = (e, data) => {
    window.open(`${data.dataLink}`, '_blank')
  }


  let getRoleId = (childData) => {
    setcondroleId(childData)
  }

  let getJbConditionId = (childData) => {
    setjbConditionId(childData)
  }

  let getValueForApproval = (childData) => {
    setValueForApproval(childData)
  }

  Array.prototype.sum = function (prop) {
    var total = 0
    for (var i = 0, _len = this.length; i < _len; i++) {
      total += this[i][prop]
    }
    return total
  }


  const handleApprovalStatus = (data) => {

    setApprovalStatus(data.value)
    setRemarksModalOpen(true)
  }

  const handleRemarks = (values) => {

    let jobcardId = infos[0].jobCardId
      let invoiceUploadObj = invoiceUpload ? invoiceUpload : ''
      let ifile = invoiceUploadObj && invoiceUploadObj.base64 ? invoiceUploadObj?.base64?.split(',')  : ''
      let invoiceUpload64 = ifile ? ifile?.[1] : invoiceUploadObj
    let approvalData = {
      remarks: values.remarks,
      jobCardId: jobcardId,
      approvalStatus: approvalStatus,
    }
    if(invoiceUpload64){
      approvalData.docFile = invoiceUpload64
    }
    setRemarksModalOpen(false)

    if (values.remarks) {
      updateApprovalStatus(approvalData).then(()=>{
        window.location.href = '/jobcard';
      })
    }
  }

  const validateSchema = yup.object({
    jobcardType: yup.string().required(jobCardValidations.JOBCARD_TYPE_REQUIRED),
    jobcardActivity: yup.string().optional().nullable(),
    refNo: yup.string().optional().nullable(),
    vehicleNumber: yup.string().required(jobCardValidations.VEHICLE_NO_REQUIRED),
    branch: yup.string().required(jobCardValidations.BRANCH_REQUIRED),
    quotationNumber: yup.string().matches(/^([A-Za-z-0-9])+$/, jobCardValidations.INVALID_CHARACTERS),
    quotationAmount: yup.string().matches(/^[0-9]+$/, jobCardValidations.ONLY_NO_REQUIRED),
    inDate: yup.string().required(jobCardValidations.VEHICLE_IN_DATE_REQUIRED),
    meterReading: yup.string().matches(/^[0-9]+$/, jobCardValidations.ONLY_NO_REQUIRED),
    adjustAmt: yup.string().matches(/^[0-9]+$/, jobCardValidations.ONLY_NO_REQUIRED),
    dealer: yup.string().required(jobCardValidations.VENDOR_REQUIRED),
    invoiceNumber: yup.string().required(jobCardValidations.BILL_NO_REQUIRED),
    outDate: yup.string().nullable().required(jobCardValidations.VEHICLE_OUT_DATE_REQUIRED)
  })
   

  if (loadinginfo) {
    return <LoadingPlaceholder />

  } else {

    const approvalOptions = [
      {
        key: 0,
        text: "Created",
        value: "1"
      },
      {
        key: 1,
        text: "Sent for Approval",
        value: "2"
      },
      {
        key: 2,
        text: "Approve",
        value: "3"
      },
      {
        key: 3,
        text: "Reject",
        value: "4"
      },

    ]

    const vehicleTypeNew = () => {
      let vehType
      infos[0].vehicleId && vehicleData && vehicleData?.filter((item) => {
        if (item.vehicleMasterId === infos[0].vehicleId) {
          vehType = item.vehicleType
          return vehType
        }
      })
      return vehType
    }

    return (
      <React.Fragment>
        <TitleBar Title="Edit Jobcard" LinkName='/jobcard'
          statusTitle={statusName ? statusName : 'Jobcard Created'}
          styleStatus={statusNameId === 2 ? "w3-border w3-round w3-border-blue w3-text-blue p-1" : '' ||
            statusNameId === 4 ? "w3-border w3-round w3-border-red w3-text-red p-1" : '' ||
              statusNameId === 1 ? "w3-border w3-round w3-border-orange w3-text-orange p-1" : '' ||
                statusNameId === 3 ? "w3-border w3-round w3-border-green w3-text-green p-1" : ''}
        >
          <div>
            {statusNameId < 3 ?
              <>
                <Dropdown
                  selection
                  clearable
                  className="mr-2 w3-small"
                  onChange={(event, data) => { event.stopPropagation(); handleApprovalStatus(data) }}
                  placeholder="Jobcard Status"
                  options={approvalOptions}
                />
                {/* <Button basic disabled={approvalButton} size="mini" type="button" color="blue" onClick={() => handleStatus()}>Update</Button> */}
                <AddModal onClose={() => setRemarksModalOpen(false)} open={remarksModalOpen} size="mini">
                  <Modal.Header>Remarks</Modal.Header>
                  <Formik
                    initialValues={{
                      remarks: ''
                    }}
                    validationSchema={yup.object({
                      remarks: yup.string().required("Remarks required"),
                    })
                    }
                    onSubmit={handleRemarks}
                  >
                    {({ values, isSubmitting, errors, touched, handleSubmit }) => (
                      <>
                        <Modal.Content>
                          <Container>
                            <FormUi.Field>
                              <Fieldmik name='remarks' component={MyTextArea} error={values.remarks ? false : true} />
                              {touched.remarks && errors.remarks ? <Label size='mini' prompt pointing>{errors.remarks}</Label> : ''}
                            </FormUi.Field>
                          </Container>
                        </Modal.Content>
                        <Modal.Actions>
                          <Button onClick={() => { setRemarksModalOpen(false); window.location.reload(); }} size='mini'>Cancel</Button>
                          <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} size='mini' primary>Submit</Button>
                        </Modal.Actions>
                      </>
                    )}

                  </Formik>
                </AddModal>
              </> : ''}
          </div>

        </TitleBar>
        {infos.map((object, index) => {
          let poDetails = [];
          object.jb_product_services && object.jb_product_services.map((po, index) => {
            let temp = {}
            temp.jbpsId = po.jbpsId
            temp.productName = po.psId
            temp.productCode = po.psCode
            temp.productPlaceholder = po.psName
            temp.startDate = po.startDate === "0000-00-00" ? "" : new Date(po.startDate)
            temp.endDate = po.endDate === "0000-00-00" ? "" : new Date(po.endDate)
            temp.quantity = Number(po?.quantity ? po.quantity : 1)
            temp.rate = Number(po.rate)
            temp.discount = Number(po.discount)
            temp.discountType = po.discountType
            temp.iGstPercent = Number(po.gstPercentage)
            temp.iGst = ''
            temp.cGstPercent = ""
            temp.cGst = ''
            temp.sGstPercent = ""
            temp.sGst = ''
            temp.amount = ''

            poDetails[index] = temp
          })

          let batteryDetailsObject = {
            oldSerialNumber: object?.jb_battery?.oldSerialNo,
            oldBatteryMapId: object?.jb_battery?.oldBatteryMapId,
            serialNo: {
              productInventoryId: object?.jb_battery?.productInvId,
              serialNo: object?.jb_battery?.serialNo
            },
            jbBatteryId: object?.jb_battery?.jbBatteryId,
            jobCardId: object?.jb_battery?.jobCardId,
            checkboxSelect: true,
            installationDate: object?.jb_battery?.installationDate ? object?.jb_battery.installationDate.split(" ")[0] != '0000-00-00' ? new Date(object?.jb_battery.installationDate.split(" ")[0]) : new Date() : new Date(),
            newInstallationDate: object?.jb_battery?.installationDate ? object?.jb_battery.installationDate.split(" ")[0] != '0000-00-00' ? new Date(object?.jb_battery.installationDate.split(" ")[0]) : new Date() : new Date()
          }


          return (<div className="m-2" key={index}>
            <Formik
              /* enableReinitialize */
              initialValues={{
                jobCardId: object.jobCardId,
                JobcardActivity: object.jobcardActivityId,
                jobcardTypeName: object.jb_type.jobCardType,
                jobCardNo: object.jobCardno,
                jobcardActivityName: object.jobcardActivityName,
                jobcardActivity: object.jobcardActivityId,
                vehicleType: vehicleTypeNew(),
                refNo: object.refNo,
                branch: object.branchId,
                jobcardType: object.jobCardTypeId,
                meterReading: parseInt(object.meterReading),
                inDate: object.vehicleInDate === null ? '' : new Date(object.vehicleInDate),
                vehicleNumber: object.vehicleId,
                outDate: object?.vehicleOutDate ? new Date(object.vehicleOutDate) : '',
                dealer: object.vendorId,
                jbInvId: object.jb_invoice ? object.jb_invoice.jbInvId : '',
                quotationNumber: object.jb_invoice ? object.jb_invoice.quotationNo : '',
                quotationAmount: object.jb_invoice ? parseInt(object.jb_invoice.quotationAmt) : '',
                adjustmentAmount: parseInt(object.adjustmentAmt),
                subTotal: "",
                finalAmount: '',
                quotation: object?.jb_invoice?.quotationDoc ? object.jb_invoice.quotationDoc : '',
                invoiceNumber: object.jb_invoice ? object.jb_invoice.invoiceNo : '',
                document: object?.document ? object.document : '',
                invoiceDate: object.jb_invoice && object.jb_invoice.invoiceDate !== null ? new Date(object.jb_invoice.invoiceDate) : '',
                tyreDetailsFromAdd: tyreDetails,
                tyreDetails: tyreDetails,
                batteryDetails: object.jb_battery,
                productDetails: poDetails ? poDetails : emptyProductDetails,
                invoiceUpload: object.document ? object.document : '',
                customerNotes: object.remarks,

              }}

              validationSchema={validateSchema}

              onSubmit={(value, { setSubmitting }) => {

                setSubmitting(false)
                let jobcardNumber = value.jobcardNumber
                let refNo = value.refNo
                let vehicleId = value.vehicleNumber
                let jobCardId = value.jobCardId
                let branch = value.branch
                let meterReading = value.meterReading ? value.meterReading : latestHistory ? latestHistory[0].meterReading : ''
                let inDate = value.inDate ? moment(value.inDate).format('DD-MM-YYYY') : ''
                let outDate = value.outDate ? moment(value.outDate).format('DD-MM-YYYY') : ''
                let dealer = value.dealer

                let adjustAmt = value.adjustmentAmount
                let quotationNumber = value.quotationNumber
                let quotationAmount = value.quotationAmount
                let jbInvId = value.jbInvId
                let qfile = value.quotation && value.quotation.base64 ? value.quotation.base64.split(",") : ''
                let quotation64 = qfile ? qfile[1] : value.quotation
                let invoiceNumber = value.invoiceNumber
                let invoiceDate = value.invoiceDate ? moment(value.invoiceDate).format('DD-MM-YYYY') : ''
                let invoiceUpload = value.invoiceUpload ? value.invoiceUpload : ''
                let ifile = invoiceUpload && invoiceUpload.base64 ? invoiceUpload?.base64?.split(',')  : ''
                let invoiceUpload64 = ifile ? ifile?.[1] : value.invoiceUpload
                let customerNotes = value.customerNotes
                

                const psLineItems = [];
                value.productDetails.map((product, index) => {
                  let temp = {}
                  temp.jbpsId = product.jbpsId
                  temp.psCode = product.productCode
                  temp.psId = product.productName
                  temp.quantity = product.quantity
                  temp.rate = product.rate
                  temp.psPrice = product.rate
                  temp.psAmount = product.rate * product.quantity
                  temp.igstPercent = product.iGstPercent
                  temp.igstAmount = product.iGst
                  temp.cgstPercent = product.cGstPercent
                  temp.cgstAmount = product.cGst
                  temp.sgstPercent = product.sGstPercent
                  temp.sgstAmount = product.sGst
                  temp.gstPercentage = product.iGstPercent || (product.cGstPercent * 2)
                  temp.gstAmount = product.iGst || (product.cGst * 2)
                  temp.discount = product.discount
                  temp.finalDiscount = product.discount
                  temp.discountType = product.discountType
                  temp.taxableAmount = product.rate * product.quantity - product.discount
                  temp.totalAmt = product.amount
                  psLineItems[index] = temp
                });

                /* TYRE */
                let tyreItems = [];
                let selectedRemoveTyre = 0;
                let tyreChangesCheckFlag = 0;
                /* value.tyreDetails.map((tyre, index) => {
                  let temp = {}
                  temp.tyreRun = tyre.tyreRun
                  temp.tyrePositionId = tyre.tyrePositionId
                  temp.installationDate = tyre.installationDate
                  temp.tyrePostionName = tyre.tyrePostionName
                  temp.oldTyreMapId = tyre.oldTyreMapId
                  temp.oldSerialNo = tyre.oldSerialNo
                  temp.old_serial_no = tyre.oldSerialNo
                  temp.productInvId = tyre.serialNo.productInvId
                  temp.serialNo = tyre.serialNo.serialNo

                  tyreItems[index] = temp
                }); */

                if (value.jobcardActivity == 1) {
                  value.tyreDetailsFromAdd.map((tyre, index) => {
                    let temp = {}
                    /* ADD */
                    temp.jbTyreId = tyre.jbTyreId
                    temp.tyreRun = tyre.tyreRun
                    temp.tyrePositionId = tyre.tyrePositionId
                    temp.installationDate = tyre.installationDate
                    temp.tyrePostionName = tyre.tyrePositionName
                    temp.productInvId = tyre?.serialNo?.productInventoryId != null || tyre?.serialNo?.productInventoryId != undefined ? tyre.serialNo.productInventoryId : tyre.tyreInvId
                    temp.serialNo = tyre?.serialNo?.serialNo ? tyre.serialNo.serialNo : tyre.serialNo
                    temp.isDeleted = tyre.removeJobfromList == 0 ? 0 : 1
                    tyreItems[index] = temp
                  });
                } else if (value.jobcardActivity == 2 || value?.jobcardActivity == 3) {
                  value.tyreDetails.map((tyre, index) => {
                    let temp = {}
                    temp.jbTyreId = tyre.jbTyreId
                    temp.tyreRun = tyre.tyreRun
                    temp.tyrePositionId = tyre.tyrePositionId
                    temp.installationDate = tyre.installationDate
                    temp.tyrePostionName = tyre.tyrePositionName

                    /* REMOVE */
                    if (value.jobcardActivity == 2) {
                      temp.old_serial_no = tyre.oldSerialNo
                      temp.oldSerialNo = tyre.oldSerialNo
                      temp.oldTyreMapId = tyre.oldTyreMapId
                      temp.isDeleted = tyre.checkboxSelect ? 0 : 1
                    }

                    /* REPLACE */
                    if (value.jobcardActivity == 3) {
                      temp.old_serial_no = tyre.oldSerialNo
                      temp.oldSerialNo = tyre.oldSerialNo
                      temp.oldTyreMapId = tyre.oldTyreMapId
                      temp.productInvId = tyre?.serialNo?.productInventoryId != null || tyre?.serialNo?.productInventoryId != undefined ? tyre.serialNo.productInventoryId : tyre.tyreInvId
                      temp.serialNo = tyre?.serialNo?.serialNo ? tyre.serialNo.serialNo : tyre.serialNo
                      temp.isDeleted = tyre.removeJobfromList == 0 ? 0 : 1
                    }

                    tyreItems[index] = temp
                  });
                }

                /* BATTERY */
                /* ,value.batteryDetails ? {
                      productInvId: value.batteryDetails.serialNo.productInventoryId,
                      serialNo: value.batteryDetails.serialNo.serialNo,
                      oldSerialNo: value.batteryDetails.oldSerialNumber,
                      oldBatteryMapId: value.batteryDetails.oldBatteryMapId
                    } : null,
                    tyreDetails: tyreItems */

                let batteryItem = [];
                let batteryChangesCheckFlag = 0;
                if (value.jobcardActivity == 4) {
                  /* ADD BATTERY */
                  let temp = {}
                  temp.jbBatteryId = value.batteryDetails.jbBatteryId
                  temp.productInvId = value.batteryDetails.productInvId
                  temp.serialNo = value.batteryDetails.serialNo
                  temp.batteryInstallationDate = value.batteryDetails.batteryInstallationDate
                  batteryItem.push(temp)
                }
                else if (value.jobcardActivity == 5) {
                  /* REMOVE BATTERY */
                  let temp = {}
                  temp.jbBatteryId = value.batteryDetails.jbBatteryId
                  temp.oldSerialNo = value.batteryDetails.oldSerialNumber
                  temp.oldBatteryMapId = value.batteryDetails.oldBatteryMapId
                  batteryItem = temp
                }
                else if (value.jobcardActivity == 6) {
                  /* REPLACE BATTERY */
                  let temp = {}
                  temp.jbBatteryId = value.batteryDetails.jbBatteryId
                  temp.productInvId = value.batteryDetails.serialNo.productInventoryId
                  temp.serialNo = value.batteryDetails.serialNo.serialNo
                  temp.oldSerialNo = value.batteryDetails.oldSerialNumber
                  temp.oldBatteryMapId = value.batteryDetails.oldBatteryMapId
                  temp.batteryInstallationDate = value.batteryDetails.newInstallationDate
                  batteryItem = temp
                }

                let token = localStorage.getItem('apiToken')
                let userId = localStorage.getItem('userId')
                let customerNo = localStorage.getItem('customerNo')
                let jobcard = JSON.stringify
                  ({
                    jobCardNo: jobcardNumber,
                    api_token: token,
                    userId: userId,
                    jobCardId: jobCardId,
                    customerNo: customerNo,
                    jobCardTypeId: value.jobcardType,
                    refNo: refNo,
                    vehicleId: vehicleId,
                    branchId: branch,
                    meterReading: meterReading,
                    vendorId: dealer,
                    batteryDetails: value.batteryDetails,
                    tyreDetails: tyreItems,
                    vehicleInDate: inDate,
                    vehicleOutDate: outDate,
                    invoiceDetails: {
                      jbInvId: jbInvId,
                      quotationNo: quotationNumber,
                      quotationAmt: quotationAmount,
                      quotationFile: quotation64,
                      invoiceNo: invoiceNumber,
                      invoiceDate: invoiceDate,
                    },
                    docFile: invoiceUpload64,
                    remarks: customerNotes,
                    productDetails: psLineItems,
                    totalAmt: value.finalAmount,
                    adjustmentAmt: adjustAmt,
                    approverRoleId: condroleId[0],
                    jbConditionId: jbConditionId ? jbConditionId.jbConditionId : '',
                    conditionId: jbConditionId ? jbConditionId.conditionId : '',
                    conditionName: jbConditionId ? jbConditionId.conditionName : '',
                    startValue: jbConditionId ? jbConditionId.startValue : '',
                    endValue: jbConditionId ? jbConditionId.endValue : '',
                    roleId: jbConditionId ? jbConditionId.roleId : '',
                    valueForApproval: valueForApproval ? valueForApproval : '',

                  })


                Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/update`, jobcard, {
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('apiToken')
                  }
                }).then(response => {

                  if (response.data.status === 1) {
                    cogoToast.success(response.data.message)
                    setSubmitting(false)
                    window.location.href = '/jobcard'

                  } else {
                    cogoToast.warn(response.data.message)
                    setSubmitting(false)

                  }
                })

              }}
            >
              {({ values, errors, touched, isSubmitting }) => {
                values.subTotal = Number(values.productDetails.sum("amount")).toFixed(2)

                values.finalAmount = values.adjustmentAmount ? Number(values.subTotal - values.adjustmentAmount).toFixed(2) : values.subTotal


                return (
                  <Formiker>
                    <div className="m-2">
                      <Segment>
                        <div className="ui form tiny">
                          <FormUi.Group>
                            <FormUi.Field >
                              <label className="labelName w3-text-blue">Basic Details</label>
                            </FormUi.Field>
                          </FormUi.Group>
                          <FormUi.Group>
                            <FormUi.Field width={4}>
                              <label className="labelName">{jobcardTitles.JOBCARD_NO} *</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik autoComplete="off" component={MyInput} error={values.jobCardNo ? false : true} name="jobCardNo" placeholder="Jobcard No." readOnly />
                              {touched.jobCardNo && errors.jobCardNo ? <div className="w3-tiny w3-text-red p-bold-600">{errors.jobCardNo}</div> : ''}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field width={3}>
                              <label className="labelName">{jobcardTitles.REF_NO}</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik autoComplete="off" component={MyInput} name="refNo" placeholder="Reference No." />
                              {touched.refNo && errors.refNo ? <div className="w3-tiny w3-text-red p-bold-600">{errors.refNo}</div> : ''}
                            </FormUi.Field>

                          </FormUi.Group>

                          {values.jobcardTypeName == "BATTERY" || values.jobcardTypeName == "TYRE" ?
                            <FormUi.Group >
                              <FormUi.Field width={4}>
                                <label className="labelName">{jobcardTitles.JOBCARD_TYPE} *</label>
                              </FormUi.Field>
                              <FormUi.Field width={3}>
                                <Fieldmik autoComplete="off" component={MyJobcardType} error={values.jobcardType ? false : true} name="jobcardType" value={values.jobcardType} disabled clearable={false} className="placeholder-black" />
                                {touched.jobcardType && errors.jobcardType ? <div className="w3-tiny w3-text-red p-bold-600">{errors.jobcardType}</div> : ''}
                              </FormUi.Field>

                              {values.jobcardTypeName == "BATTERY" || values.jobcardTypeName == "TYRE" ?
                                <>
                                  <FormUi.Field width={1} />
                                  <FormUi.Field width={3}>
                                    <label className="labelName">{jobcardTitles.JOBCARD_ACTIVITY}</label>
                                  </FormUi.Field>
                                  <FormUi.Field width={3}>
                                    <Fieldmik
                                      autoComplete="off"
                                      style={{ width: '100%' }}
                                      component={MyInput}
                                      name="jobcardActivity"
                                      value={values?.jobcardActivityName ? values.jobcardActivityName.split(" ")[0] : ''}
                                      readOnly
                                      type="" />

                                    {touched.jobcardActivity && errors.jobcardActivity ? <div className="w3-tiny w3-text-red p-bold-600">{errors.jobcardActivity}</div> : ''}
                                  </FormUi.Field>

                                </> : null}
                            </FormUi.Group>
                            : null}

                          <FormUi.Group >
                            <FormUi.Field width={4}>
                              <label className="labelName">{jobcardTitles.VEHICLE_NO} *</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik error={values.vehicleNumber ? false : true} name="vehicleNumber" component={MyVehicleNumber} value={values.vehicleNumber} disabled clearable={false} className="placeholder-black" getAllRecords={true} />
                              {touched.vehicleNumber && errors.vehicleNumber ? <div className="w3-tiny w3-text-red p-bold-600">{errors.vehicleNumber}</div> : ''}
                            </FormUi.Field>
                            <FormUi.Field width={1} />

                            <FormUi.Field width={3}>
                              <label className="labelName">{jobcardTitles.VEHICLE_TYPE}</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik readOnly autoComplete="off" name="vehicleType" value={values.vehicleType} />
                              {touched.vehicleType && errors.vehicleType ? <div className="w3-tiny w3-text-red p-bold-600">{errors.vehicleType}</div> : ''}
                            </FormUi.Field>
                          </FormUi.Group>
                          <FormUi.Group >
                            <FormUi.Field width={4}>
                              <label className="labelName">{jobcardTitles.METER_READING}</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik type="number" autoComplete="off" min={1} name="meterReading" value={values.meterReading} />
                              {latestHistory.length > 0 && latestHistory[0].meterReading > values.meterReading ? <div className="w3-tiny w3-text-red p-bold-600">Should be Greater Than {latestHistory[0].meterReading ? latestHistory[0].meterReading : 0}</div> : ''}
                              {latestHistory.length > 0 && latestHistory[0].meterReading > values.meterReading ? setMeterDisabled(true) : setMeterDisabled(false)}
                              {touched.meterReading && errors.meterReading ? <div className="w3-tiny w3-text-red p-bold-600">{errors.meterReading}</div> : ''}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field width={3}>
                              <label className="labelName">{jobcardTitles.BRANCH}*</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik autoComplete="off" placeholder="Branch" gstAvailable="gstExempted" name="branch" error={values.branch ? false : true} component={MyBranchAddVehicle} value={values.branch} />
                              {touched.branch && errors.branch ? <div className="w3-tiny w3-text-red p-bold-600">{errors.branch}</div> : ''}
                            </FormUi.Field>

                          </FormUi.Group>
                          <FormUi.Group>
                            <FormUi.Field width={4}>
                              {values?.jobcardTypeName?.toLocaleLowerCase() === "fuel" ?
                                <label className="labelName">{jobcardTitles.VEHICLE_EXPENSE_DATE} *</label>
                                :
                                <label className="labelName">{jobcardTitles.VEHICLE_IN_DATE} *</label>
                              }
                            </FormUi.Field>
                            <FormUi.Field className="datepic" width={3}>
                              <DateData
                                name="inDate"
                                autoComplete="off"
                                popperClassName="dateTime"
                                dateFormat="dd-MM-yyyy"
                                placeholderText="In Date"
                                selected={values.inDate}
                                selectsStart
                                startDate={values.inDate}
                                endDate={values['outDate']}
                                timeIntervals={5}
                                customInput={<FormUi.Input error={values.inDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                              />
                              {touched.inDate && errors.inDate ? <div className="w3-tiny w3-text-red p-bold-600">{errors.inDate}</div> : ''}
                            </FormUi.Field>
                            {values?.jobcardTypeName?.toLocaleLowerCase() === "fuel" ? null
                              :
                              <>
                                <FormUi.Field width={1} />
                                <FormUi.Field width={3}>
                                  <label className="labelName">{jobcardTitles.VEHICLE_OUT_DATE}*</label>
                                </FormUi.Field>
                                <FormUi.Field className="datepic" width={3}>
                                  <DateData
                                    name="outDate"
                                    selected={values.name}
                                    selectsEnd
                                    startDate={values['inDate']}
                                    endDate={values.name}
                                    minDate={values['inDate']}
                                    autoComplete="off"
                                    popperClassName="dateTime"
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="Out Date"
                                    timeIntervals={5}
                                    customInput={<FormUi.Input autoComplete="off" icon="time" className="dateWidth" iconPosition="left" />}
                                  />
                                  {touched.outDate && errors.outDate ? <div className="w3-tiny w3-text-red p-bold-600">{errors.outDate}</div> : ''}
                                </FormUi.Field>
                              </>}
                          </FormUi.Group>
                          <FormUi.Group >
                            <FormUi.Field width={4}>
                              <label className="labelName">{jobcardTitles.VENDOR} *</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik autoComplete="off" placeholder="Select Vendor" name="dealer" component={MyVendor} value={values.dealer} />
                              {touched.dealer && errors.dealer ? <div className="w3-tiny w3-text-red p-bold-600">{errors.dealer}</div> : ''}
                            </FormUi.Field>
                          </FormUi.Group>
                        </div>
                      </Segment>

                      <Segment>
                        <div className="ui form subform tiny">
                          <FormUi.Group >
                            <FormUi.Field >
                              <label className="labelName w3-text-blue">Bill Details</label>
                            </FormUi.Field>
                          </FormUi.Group>
                          <FormUi.Group >
                            <FormUi.Field width={4}>
                              <label className="labelName">Quotation No</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik autoComplete="off" name="quotationNumber" placeholder="Quotation No."
                                label={<Button type="button" disabled={values.quotation ? false : true}
                                  basic dataLink={values.quotation} icon onClick={handleDoc}>
                                  <Icon name="download" color={values.quotation ? "green" : ""} /></Button>}
                                labelPosition="right" component={MyNormalInput} />
                              {touched.quotationNumber && errors.quotationNumber ? <div className="w3-tiny w3-text-red p-bold-600">{errors.quotationNumber}</div> : ''}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field width={3}>
                              <label className="labelName">Quotation Amount</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik autoComplete="off" name="quotationAmount" placeholder="Amount" />
                              {touched.quotationAmount && errors.quotationAmount ? <div className="w3-tiny w3-text-red p-bold-600">{errors.quotationAmount}</div> : ''}
                            </FormUi.Field>
                          </FormUi.Group>
                          {/* <FormUi.Group >
                            <FormUi.Field width={4}>
                              <label className="labelName">Quotation</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik autoComplete="off" name="quotation" label={<Button type="button" disabled={values.quotation ? false : true}
                                basic dataLink={values.quotation} icon onClick={handleDoc}><Icon name='download' /></Button>}
                                labelPosition="right"
                                buttonName={values.quotation ? 'Replace File' : "Choose File"} placeholder="Quotation" className="subform" component={UploadFile} typer={['.pdf']} />
                              {touched.quotation && errors.quotation ? <div className="w3-tiny w3-text-red p-bold-600">{errors.quotation}</div> : ''}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                               </FormUi.Group> */}
                          <FormUi.Group >
                            <FormUi.Field width={4}>
                              <label className="labelName">Vendor Bill File</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik name="invoiceUpload" placeholder="Note" buttonName={values.invoiceUpload ? 'File Selected/Uploaded' : "Upload File"} component={UploadFile} typer={['.pdf, .jpeg ,.jpg, .png']} onChangeExtra={(value)=>setInvoiceUpload(value)} />
                              {touched.invoiceUpload && errors.invoiceUpload ? <div className="w3-tiny w3-text-red p-bold-600">{errors.invoiceUpload}</div> : ''}
                            </FormUi.Field>
                          </FormUi.Group>                       
                          <FormUi.Group >
                            <FormUi.Field width={4}>
                              <label className="labelName">Bill No. *</label>
                            </FormUi.Field>
                            <FormUi.Field width={3}>
                              <Fieldmik onKeyUp = {(e) => checkInvoiceNo(e)} autoComplete="off" name="invoiceNumber" placeholder="Bill No"
                                label={<Button type="button" disabled={values.document ? false : true}
                                  basic dataLink={values.document} icon onClick={handleDoc}>
                                  <Icon name="download" color={values.document ? "green" : ""} /></Button>}
                                labelPosition="right" component={MyNormalInput} />
                              {touched.invoiceNumber && errors.invoiceNumber ? <div className="w3-tiny w3-text-red p-bold-600">{errors.invoiceNumber}</div> : ''}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field width={3}>
                              <label className="labelName">Bill Date</label>
                            </FormUi.Field>
                            <FormUi.Field className="datepic" width={3}>
                              <DateData
                                name="invoiceDate"
                                autoComplete="off"
                                popperClassName="dateTime"
                                dateFormat="dd-MM-yyyy"
                                placeholderText="Date"
                                timeIntervals={5}
                                customInput={<Input autoComplete="off" icon="time" className="dateWidth2" iconPosition="left" />}
                              />
                              {touched.invoiceDate && errors.invoiceDate ? <div className="w3-tiny w3-text-red p-bold-600">{errors.invoiceDate}</div> : ''}
                            </FormUi.Field>
                          </FormUi.Group>
                        </div>
                      </Segment>

                      {/* {values.jobcardType ? getProduct(values) : ''} */}

                      {values.jobcardTypeName === "BATTERY" && values.inDate && vehicleInfo.length > 0 ?
                        <BatteryEdit
                          vehicleIdrole={values.vehicleNumber}
                          conditionRoleId={getRoleId}
                          cardTypeId={values.jobcardType}
                          vehicleInfoarray={vehicleInfo}
                          jbValues={values}
                          vehicleInDate={values.inDate}
                          jbConditionId={getJbConditionId}
                          valueForApproval={getValueForApproval}
                        />
                        : ""
                      }

                      {values.jobcardTypeName === "SERVICES" && vehicleInfo.length > 0 ?
                        <Services
                          cardTypeId={values.jobcardType}
                          vehicleIdrole={values.vehicleNumber}
                          conditionRoleId={getRoleId}
                          amount={values.finalAmount}
                          mode={1}
                          jbConditionId={getJbConditionId}
                          valueForApproval={getValueForApproval}
                        />
                        :
                        ""
                      }

                      {values.jobcardTypeName === "TYRE" && vehicleInfo.length > 0 ?
                        <TyreEdit
                          vehicleIdrole={values.vehicleNumber}
                          conditionRoleId={getRoleId}
                          cardTypeId={values.jobcardType}
                          vehicleInfoarray={vehicleInfo}
                          jbValues={values}
                          maxTyreRun={values.tyreRun}
                          // tyreDetails={getTyrNo}
                          jbConditionId={getJbConditionId}
                          valueForApproval={getValueForApproval}
                        />
                        :
                        ""
                      }


                      <Segment>
                        <div className="ui form subform tiny">
                          <AddProduct />
                          <Segment>
                            <FormUi.Group widths="2">
                              <FormUi.Field>
                                <label>Notes</label>
                                <Fieldmik as="textarea" rows="3" name="customerNotes" placeholder="Enter Notes" />
                                {touched.customerNotes && errors.customerNotes ? <div className="w3-tiny w3-text-red p-bold-600">{errors.customerNotes}</div> : ''}
                              </FormUi.Field>
                              <Divider vertical><span className="labelName w3-text-light-grey">|</span></Divider>

                            </FormUi.Group>
                          </Segment>
                        </div>
                      </Segment>

                      {props?.location?.state?.data?.adminEditFlag == 1 ?
                        <center>
                          <Button secondary size="mini" onClick={(e) => { e.stopPropagation(); window.location.href = '/jobcard' }}>Close</Button>
                        </center>
                        :
                        <center>
                          <Button disabled={isSubmitting || meterDisabled || billNoExists} primary size="mini" type="submit">Submit</Button>
                          <Button secondary size="mini" onClick={(e) => { e.stopPropagation(); window.location.href = '/jobcard' }}>Close</Button>
                        </center>
                      }
                      {/* <center><Button primary size="mini" onClick={(e) => { e.stopPropagation(); window.location.href = '/jobcard' }}>Close</Button></center> */}
                    </div>
                  </Formiker>
                )
              }}
            </Formik>
          </div>
          )
        }
        )}

        {infos && infos?.length > 0 ?
          <VehicleJobcardHistory currentVehId={props.location?.state?.id} getVehicleInfo={infos} getLatestHistory={fetchLatestHistory} /> : ''
        }
      </React.Fragment>
    )
  }
}

const mapStatetoProps = (state) => ({
  products: state.getProduct.product,
  vehicleData: state.getVehicle.vehicle.resultSet
})

export default connect(mapStatetoProps, { getVehicle, updateApprovalStatus })(EditJobcard)